import styled from '@emotion/styled';

export const GrayscaleWrapper = styled.div<{ greyed: boolean }>`
  display: inline-flex;
  align-items: center;
  ${(props) =>
    props.greyed &&
    `
  filter: grayscale();
`}
`;

export const ConditionnalBold = styled.span<{ isBold: boolean }>`
  font-weight: ${(props) => (props.isBold ? 600 : 400)};
`;
